// extracted by mini-css-extract-plugin
export default {"layout":"adminUserCard_layout__kpj8F","cover":"adminUserCard_cover__6RbLw","adminCardAvatar":"adminUserCard_adminCardAvatar__RP8+f","tweetInfo":"adminUserCard_tweetInfo__17ttd"};